import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button, Card, Col, Form, Input, PageHeader, Row, Spin } from "antd";

import { CheckPermission } from "scripts/helpers";
import { setRoute } from "scripts/reducer";
import { Permissions } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";

import TextEditor from "components/TextEditor";

const Component = ({ onSetRoute, routeName, parentName, permissions }) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { loaded, submitting, text } = state;
	const [form] = Form.useForm();

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));

				if (values.text) {
					values.text = values.text.replaceAll(/<\/p><p>/g, "<br />");
					values.text = values.text.replaceAll("<br>", "");
					values.text = values.text.replaceAll(
						/<\/p><p\s+class="[^"]*">/g,
						"<br />"
					);
				}

				API.tac.update(values).finally(() => {
					setState((prevState) => ({ ...prevState, submitting: false }));
				});
			});
		}
	};

	const componentDidMount = () => {
		onSetRoute({ openKey: parentName, selectedKey: routeName });

		API.tac
			.details()
			.then(({ data }) => {
				if (permissions.update) {
					setState((prevState) => ({ ...prevState, loaded: true }));

					form.setFieldsValue(data);
				} else {
					setState((prevState) => ({ ...prevState, ...data, loaded: true }));
				}
			})
			.catch(() => {
				setState((prevState) => ({ ...prevState, loaded: true }));
			});
	};

	useEffect(componentDidMount, []);

	return (
		<>
			<PageHeader title={Resources.tac} />
			<Row className="sp-content-center">
				<Col xs={24} md={18} xl={16} xxl={14}>
					<Card>
						<Form layout="vertical" form={form}>
							{loaded ? (
								permissions.update ? (
									<>
										<Form.Item
											name="text"
											label={Resources.text}
											rules={Rules.required}
										>
											<TextEditor />
										</Form.Item>
										<Button
											type="primary"
											onClick={handleSubmit}
											loading={submitting}
											style={{ float: "left", marginTop: 16 }}
										>
											{Resources.confirm}
										</Button>
									</>
								) : (
									<div
										dangerouslySetInnerHTML={{
											__html: text?.replace(/\n/g, "<br />"),
										}}
									/>
								)
							) : (
								<Spin className="sp-block-spin" />
							)}
						</Form>
					</Card>
				</Col>
			</Row>
		</>
	);
};

export default connect(
	(state) => {
		return {
			permissions: {
				update: CheckPermission(state.user.permissions, Permissions.TAC_UPDATE),
			},
		};
	},
	(dispatch) => {
		return {
			onSetRoute: (data) => dispatch(setRoute(data)),
		};
	}
)(Component);
